import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import { useFavourites } from '../favourites/FavouritesContext';
import { readStoredCityLabel } from '../utils/city';
import CitySelector from './CitySelector';
import InfoMenu from './InfoMenu';
import { BrandMark, HeartIcon } from './Icons';

export default function AppHeader({ cityLabel, cities, selectedCity, onCityChange, hidden = false }) {
  const { t, toggleLocale } = useLocale();
  const { count } = useFavourites();

  // Pages that never load filter options fall back to the last city the home
  // page resolved, so the tagline stays consistent across the app.
  const city = cityLabel !== undefined ? cityLabel : readStoredCityLabel();
  const tagline = city ? t('app.taglineCity', { city }) : t('app.tagline');

  return (
    <header className={`header${hidden ? ' header--hidden' : ''}`}>
      <div className={`page header__inner${cities ? ' header__inner--with-city' : ''}`}>
        <Link to="/" className="brand">
          <span className="brand__mark">
            <BrandMark />
          </span>
          <span>
            <span className="brand__name">{t('app.name')}</span>
            <span className="brand__tagline">{tagline}</span>
          </span>
        </Link>

        <div className="header__actions">
          {cities && (
            <CitySelector cities={cities} value={selectedCity} onChange={onCityChange} />
          )}

          <Link
            to="/favourites"
            className="header__link"
            aria-label={t('favourites.title')}
            title={t('favourites.title')}
          >
            <HeartIcon size={17} filled={count > 0} />
            <span className="header__link-text">{t('favourites.title')}</span>
            {count > 0 && <span className="btn__badge">{count}</span>}
          </Link>

          <button
            type="button"
            className="locale-toggle"
            onClick={toggleLocale}
            title={t('locale.switch')}
            aria-label={t('locale.switch')}
          >
            <span className="locale-toggle__full">{t('locale.switch')}</span>
            <span className="locale-toggle__short">{t('locale.switchShort')}</span>
          </button>

          <InfoMenu />
        </div>
      </div>
    </header>
  );
}
